var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { call, put, takeLatest, select, } from 'redux-saga/effects';
import { formatTimeAvailability } from '../../../helpers/time';
import { TIME_SLOT_UNAVAILABLE_ERROR_MSG } from '../../constants';
import { actions as dateActions } from '../dateAvailability/actions';
import { runActionAfterDelay } from '../../utils/sagas';
import { getOPCO } from '../../utils/selectors';
import { getMinAdvancePeriod, getSelectedStoreId, getSelectedStoreServiceId, } from '../../location/selectedStore/selectors';
import { getSelectedDateValue } from '../dateAvailability';
import { getBookingId } from '../../appointment';
import { actions, ActionTypes } from './actions';
import { fetchTimeAvailability } from './requests';
import { getAvailableTimeSlots } from './utils';
import { getIsSelectedTimeAvailable } from './selectors';
export function loadTimeAvailability() {
    var companyId, serviceId, selectedDate, minAdvancePeriod, bookingId, opco, timeZone, fetchTimeAvailabilityParams, response, formattedTimeSlotItems, timeSlotItems, isSelectedTimeAvailable, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 16, , 18]);
                return [4 /*yield*/, select(getSelectedStoreId)];
            case 1:
                companyId = _a.sent();
                return [4 /*yield*/, select(getSelectedStoreServiceId)];
            case 2:
                serviceId = _a.sent();
                return [4 /*yield*/, select(getSelectedDateValue)];
            case 3:
                selectedDate = _a.sent();
                return [4 /*yield*/, select(getMinAdvancePeriod)];
            case 4:
                minAdvancePeriod = _a.sent();
                return [4 /*yield*/, select(getBookingId)];
            case 5:
                bookingId = _a.sent();
                return [4 /*yield*/, select(getOPCO)];
            case 6:
                opco = _a.sent();
                timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                fetchTimeAvailabilityParams = {
                    companyId: companyId,
                    serviceId: serviceId,
                    date: selectedDate,
                    timeZone: timeZone,
                    bookingId: bookingId,
                };
                return [4 /*yield*/, call(fetchTimeAvailability, fetchTimeAvailabilityParams)];
            case 7:
                response = _a.sent();
                formattedTimeSlotItems = [];
                timeSlotItems = getAvailableTimeSlots(response === null || response === void 0 ? void 0 : response.times, minAdvancePeriod);
                formattedTimeSlotItems = formatTimeAvailability(timeSlotItems, opco);
                if (!(formattedTimeSlotItems.length === 0)) return [3 /*break*/, 10];
                return [4 /*yield*/, put(dateActions.deselectDateAvailabilityItem())];
            case 8:
                _a.sent();
                return [4 /*yield*/, put(dateActions.markDatesUnavailable([selectedDate]))];
            case 9:
                _a.sent();
                return [3 /*break*/, 12];
            case 10: return [4 /*yield*/, put(actions.loadTimeAvailabilitySuccess(formattedTimeSlotItems))];
            case 11:
                _a.sent();
                _a.label = 12;
            case 12: return [4 /*yield*/, select(getIsSelectedTimeAvailable)];
            case 13:
                isSelectedTimeAvailable = _a.sent();
                if (!!isSelectedTimeAvailable) return [3 /*break*/, 15];
                return [4 /*yield*/, put(actions.deselectTimeAvailabilityItem())];
            case 14:
                _a.sent();
                throw new Error(TIME_SLOT_UNAVAILABLE_ERROR_MSG);
            case 15: return [3 /*break*/, 18];
            case 16:
                error_1 = _a.sent();
                return [4 /*yield*/, put(actions.loadTimeAvailabilityFailure(error_1))];
            case 17:
                _a.sent();
                return [3 /*break*/, 18];
            case 18: return [2 /*return*/];
        }
    });
}
export function sagas() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(ActionTypes.LOAD_TIME_AVAILABILITY, loadTimeAvailability)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeLatest(ActionTypes.LOAD_TIME_AVAILABILITY_FAILURE, function () {
                        return runActionAfterDelay(actions.resetTimeAvailabilityError());
                    })];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
